module.exports = __webpack_public_path__ + "img/vard4.1589dea8.png";